import React from "react";
import GlobalContextProvider from "./src/context/global-context-provider";
import "./src/style/global.css";
import * as Sentry from "@sentry/gatsby";

Sentry.init({
  dsn: "https://8df95242feec76cb64d3ae01d37117a5@o4508301035831296.ingest.de.sentry.io/4508646816677968",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.1,

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

export const wrapRootElement = ({ element }) => {
  return <GlobalContextProvider>{element}</GlobalContextProvider>;
};
